import React, { useContext, useEffect, useState } from "react";
import HttpContext from "../../../../contexts/HTTP/HttpContext";
import { ERRORLOG_STATUS } from "./../../../../constants";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  FormControl,
  InputLabel,
  TextField,
  Autocomplete
} from "@mui/material";

function StatusDropdown({ value, onChange }) {
  const [locationList, setLocationList] = useState([
    // "No Changes",
    // "Incomplete",
    // "Added",
    // "Error",
    // "Edited",
    // "AllSyncConnectionError"
    ERRORLOG_STATUS.NOCHANGES,
    ERRORLOG_STATUS.INCOMPLETE,
    ERRORLOG_STATUS.ADDED,
    ERRORLOG_STATUS.ERROR,
    ERRORLOG_STATUS.EDITED,
    //ERRORLOG_STATUS.SYNCED,
    ERRORLOG_STATUS.ALLSYNC_CONNECTIONERROR,
    ERRORLOG_STATUS.SINGLESYNC_CONNECTIONERROR
  ]);
  const { get, post } = useContext(HttpContext);

  useEffect(() => {
    async function getDropLoc() {
      //   const res = await get("/kiosk/getAllSubscription");
      //   if (res.status === 200) {
      //     let locationCodes = res.data.map(location => location.locationCode);
      //     setLocationList(locationCodes);
      //   }
    }

    getDropLoc();
  }, []);

  return (
    <div style={{ minWidth: "10rem" }}>
      <FormControl fullWidth>
        <Autocomplete
          disablePortal
          id="cblocationoptions"
          options={locationList}
          onChange={onChange}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              variant="outlined"
              name="name"
              label="Status"
            />
          )}
        />
      </FormControl>
    </div>
  );
}

export default StatusDropdown;
